import { render, staticRenderFns } from "./ImportPreviewModal.vue?vue&type=template&id=220e1aa2&scoped=true"
import script from "./ImportPreviewModal.vue?vue&type=script&lang=ts"
export * from "./ImportPreviewModal.vue?vue&type=script&lang=ts"
import style0 from "./ImportPreviewModal.vue?vue&type=style&index=0&id=220e1aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e1aa2",
  null
  
)

export default component.exports